import { IntlProvider as RIProvider } from '@liveauctioneers/hammer-ui-core/intl';
import * as React from 'react';

import enGb from '@/intl/en-gb';
import { Locales } from '@/redux/modules/intl.types';

type Props = {
    children: React.ReactNode;
};

const IntlProvider = ({ children }: Props) => {
    return (
        <RIProvider
            key={Locales.enGb}
            locale={Locales.enGb}
            messages={enGb}
        >
            {children}
        </RIProvider>
    );
};

export default IntlProvider;
